import type { ClosetItem, FamilyMember } from "@/types";

export const MEMBERS: FamilyMember[] = [
  { id: "all", name: "All", icon: "💫", color: "var(--color-black)" }
  // {id: 'allison', name: 'Allison', icon: '👩', color: '#E8D5E0'},
  // {id: 'mark', name: 'Mark', icon: '👨', color: '#D5DBE8'},
  // {id: 'emma', name: 'Emma', icon: '👧', color: '#E8E0D5'},
  // {id: 'jack', name: 'Jack', icon: '👦', color: '#D5E8D9'},
  // {id: 'household', name: 'Household', icon: '🏠', color: '#E0E0E0'},
];

export const MEMBER_NAMES: Record<string, string> = {
  allison: "Allison",
  mark: "Mark",
  emma: "Emma",
  jack: "Jack",
  household: "Household"
};

export const CATEGORY_ICONS: Record<string, string> = {
  Apparel: "👔",
  Footwear: "👟",
  Home: "🏠",
  Electronics: "📱",
  Beauty: "💄",
  Accessories: "👓"
};

export const SAMPLE_ITEMS: ClosetItem[] = [
  {
    id: 1,
    brand: "Nike",
    name: "Air Force 1 '07",
    category: "Footwear",
    subcategory: "Sneakers",
    price: 110,
    date: "2025-01-14",
    member: "jack",
    color: "White",
    size: "5Y",
    emoji: "👟"
  },
  {
    id: 2,
    brand: "Lululemon",
    name: 'Align High-Rise Pant 25"',
    category: "Apparel",
    subcategory: "Pants",
    price: 98,
    date: "2025-01-10",
    member: "allison",
    color: "Black",
    size: "6",
    emoji: "👖"
  },
  {
    id: 3,
    brand: "J.Crew",
    name: "Cashmere Crewneck Sweater",
    category: "Apparel",
    subcategory: "Sweaters",
    price: 128,
    date: "2025-01-08",
    member: "allison",
    color: "Heather Grey",
    size: "S",
    emoji: "🧶"
  },
  {
    id: 4,
    brand: "Patagonia",
    name: "Better Sweater Fleece",
    category: "Apparel",
    subcategory: "Outerwear",
    price: 149,
    date: "2025-01-05",
    member: "mark",
    color: "New Navy",
    size: "L",
    emoji: "🧥"
  },
  {
    id: 5,
    brand: "Zara",
    name: "Pleated Bermuda Shorts",
    category: "Apparel",
    subcategory: "Shorts",
    price: 45.9,
    date: "2024-12-28",
    member: "emma",
    color: "Black",
    size: "XS",
    emoji: "👗"
  },
  {
    id: 6,
    brand: "Hoka",
    name: "Clifton 9",
    category: "Footwear",
    subcategory: "Running Shoes",
    price: 145,
    date: "2024-12-22",
    member: "mark",
    color: "Black/White",
    size: "10.5",
    emoji: "👟"
  },
  {
    id: 7,
    brand: "Gap Kids",
    name: "Organic Cotton Tee 3-Pack",
    category: "Apparel",
    subcategory: "T-Shirts",
    price: 29.95,
    date: "2024-12-20",
    member: "jack",
    color: "Multi",
    size: "M (8-9)",
    emoji: "👕"
  },
  {
    id: 8,
    brand: "Le Creuset",
    name: "Dutch Oven 5.5 Qt",
    category: "Home",
    subcategory: "Kitchen",
    price: 380,
    date: "2024-12-18",
    member: "allison",
    color: "Flame",
    size: "5.5 Qt",
    emoji: "🍳"
  },
  {
    id: 9,
    brand: "Apple",
    name: "AirPods Pro 2nd Gen",
    category: "Electronics",
    subcategory: "Audio",
    price: 249,
    date: "2024-12-15",
    member: "mark",
    color: "White",
    size: "\u2014",
    emoji: "🎧"
  },
  {
    id: 10,
    brand: "Adidas",
    name: "Ultraboost Light",
    category: "Footwear",
    subcategory: "Running Shoes",
    price: 190,
    date: "2024-12-12",
    member: "allison",
    color: "Cloud White",
    size: "7.5",
    emoji: "👟"
  },
  {
    id: 11,
    brand: "Carter's",
    name: "Fleece Pajama Set",
    category: "Apparel",
    subcategory: "Sleepwear",
    price: 24,
    date: "2024-12-10",
    member: "jack",
    color: "Blue Dino",
    size: "6",
    emoji: "👕"
  },
  {
    id: 12,
    brand: "Anthropologie",
    name: "Maeve Midi Dress",
    category: "Apparel",
    subcategory: "Dresses",
    price: 148,
    date: "2024-12-08",
    member: "allison",
    color: "Ivory",
    size: "S",
    emoji: "👗"
  },
  {
    id: 13,
    brand: "Stanley",
    name: "Quencher Tumbler 40oz",
    category: "Home",
    subcategory: "Drinkware",
    price: 45,
    date: "2024-12-05",
    member: "emma",
    color: "Rose Quartz",
    size: "40oz",
    emoji: "🥤"
  },
  {
    id: 14,
    brand: "North Face",
    name: "Nuptse Down Vest",
    category: "Apparel",
    subcategory: "Outerwear",
    price: 220,
    date: "2024-11-30",
    member: "mark",
    color: "TNF Black",
    size: "L",
    emoji: "🧥"
  },
  {
    id: 15,
    brand: "Aritzia",
    name: "Super Puff Crop Vest",
    category: "Apparel",
    subcategory: "Outerwear",
    price: 178,
    date: "2024-11-28",
    member: "emma",
    color: "Birch",
    size: "XS",
    emoji: "🧥"
  },
  {
    id: 16,
    brand: "Dyson",
    name: "Supersonic Hair Dryer",
    category: "Electronics",
    subcategory: "Personal Care",
    price: 429,
    date: "2024-11-25",
    member: "allison",
    color: "Nickel/Copper",
    size: "\u2014",
    emoji: "💇"
  },
  {
    id: 17,
    brand: "Old Navy",
    name: "Flex Straight Jeans",
    category: "Apparel",
    subcategory: "Jeans",
    price: 39.99,
    date: "2024-11-22",
    member: "jack",
    color: "Medium Wash",
    size: "8",
    emoji: "👖"
  },
  {
    id: 18,
    brand: "Theory",
    name: "Treeca Wool-Blend Pants",
    category: "Apparel",
    subcategory: "Pants",
    price: 295,
    date: "2024-11-18",
    member: "allison",
    color: "Black",
    size: "4",
    emoji: "👖"
  },
  {
    id: 19,
    brand: "Warby Parker",
    name: "Durand Eyeglasses",
    category: "Accessories",
    subcategory: "Eyewear",
    price: 195,
    date: "2024-11-15",
    member: "mark",
    color: "Whiskey Tortoise",
    size: "\u2014",
    emoji: "👓"
  },
  {
    id: 20,
    brand: "New Balance",
    name: "574 Classic",
    category: "Footwear",
    subcategory: "Sneakers",
    price: 89.99,
    date: "2024-11-10",
    member: "emma",
    color: "Grey/White",
    size: "7",
    emoji: "👟"
  },
  {
    id: 21,
    brand: "Cuisinart",
    name: "14-Cup Food Processor",
    category: "Home",
    subcategory: "Kitchen",
    price: 199.95,
    date: "2024-11-08",
    member: "allison",
    color: "White",
    size: "14 Cup",
    emoji: "🍽\uFE0F"
  },
  {
    id: 22,
    brand: "Dr. Barbara Sturm",
    name: "Anti-Aging Face Cream",
    category: "Beauty",
    subcategory: "Skincare",
    price: 215,
    date: "2024-11-05",
    member: "allison",
    color: "\u2014",
    size: "50ml",
    emoji: "🧴"
  },
  {
    id: 23,
    brand: "Pottery Barn",
    name: "Flax Linen Duvet Cover",
    category: "Home",
    subcategory: "Bedding",
    price: 279,
    date: "2024-10-30",
    member: "allison",
    color: "White",
    size: "King",
    emoji: "🛏\uFE0F"
  },
  {
    id: 24,
    brand: "Uniqlo",
    name: "Ultra Light Down Jacket",
    category: "Apparel",
    subcategory: "Outerwear",
    price: 79.9,
    date: "2024-10-25",
    member: "mark",
    color: "Olive",
    size: "L",
    emoji: "🧥"
  },
  {
    id: 25,
    brand: "Allbirds",
    name: "Tree Runners",
    category: "Footwear",
    subcategory: "Sneakers",
    price: 98,
    date: "2024-10-20",
    member: "mark",
    color: "Natural Black",
    size: "10.5",
    emoji: "👟"
  },
  {
    id: 26,
    brand: "H&M Kids",
    name: "Printed Sweatshirt",
    category: "Apparel",
    subcategory: "Tops",
    price: 14.99,
    date: "2024-10-18",
    member: "emma",
    color: "Light Pink",
    size: "8-10Y",
    emoji: "👚"
  },
  {
    id: 27,
    brand: "Breville",
    name: "Barista Express Espresso",
    category: "Home",
    subcategory: "Kitchen",
    price: 749.95,
    date: "2024-10-15",
    member: "mark",
    color: "Brushed Steel",
    size: "\u2014",
    emoji: "☕"
  },
  {
    id: 28,
    brand: "Madewell",
    name: "Perfect Vintage Jean",
    category: "Apparel",
    subcategory: "Jeans",
    price: 138,
    date: "2024-10-12",
    member: "allison",
    color: "Ainsworth Wash",
    size: "27",
    emoji: "👖"
  },
  {
    id: 29,
    brand: "Bose",
    name: "QuietComfort Ultra",
    category: "Electronics",
    subcategory: "Audio",
    price: 429,
    date: "2024-10-08",
    member: "mark",
    color: "Black",
    size: "\u2014",
    emoji: "🎧"
  },
  {
    id: 30,
    brand: "Bombas",
    name: "Ankle Sock 6-Pack",
    category: "Apparel",
    subcategory: "Socks",
    price: 72.6,
    date: "2024-10-05",
    member: "allison",
    color: "Mixed",
    size: "M",
    emoji: "🧦"
  },
  {
    id: 31,
    brand: "Crate & Barrel",
    name: "Weston Glass Vase",
    category: "Home",
    subcategory: "Decor",
    price: 49.95,
    date: "2024-10-01",
    member: "allison",
    color: "Clear",
    size: '12"',
    emoji: "🏺"
  },
  {
    id: 32,
    brand: "Under Armour",
    name: "Tech 2.0 SS Tee",
    category: "Apparel",
    subcategory: "T-Shirts",
    price: 25,
    date: "2024-09-28",
    member: "mark",
    color: "Academy Blue",
    size: "L",
    emoji: "👕"
  },
  {
    id: 33,
    brand: "Olaplex",
    name: "No.7 Bonding Oil",
    category: "Beauty",
    subcategory: "Haircare",
    price: 30,
    date: "2024-09-25",
    member: "allison",
    color: "\u2014",
    size: "30ml",
    emoji: "💆"
  },
  {
    id: 34,
    brand: "Birkenstock",
    name: "Arizona Sandal",
    category: "Footwear",
    subcategory: "Sandals",
    price: 110,
    date: "2024-09-20",
    member: "emma",
    color: "Mocha",
    size: "6",
    emoji: "👡"
  },
  {
    id: 35,
    brand: "West Elm",
    name: "Mid-Century Nightstand",
    category: "Home",
    subcategory: "Furniture",
    price: 399,
    date: "2024-09-15",
    member: "allison",
    color: "Acorn",
    size: "\u2014",
    emoji: "🪑"
  },
  {
    id: 36,
    brand: "Colgate",
    name: "Total Whitening Toothpaste 3-Pack",
    category: "Home",
    subcategory: "Essentials",
    price: 12.99,
    date: "2025-01-02",
    member: "household",
    color: "\u2014",
    size: "3pk",
    emoji: "🪥"
  },
  {
    id: 37,
    brand: "Mrs. Meyer's",
    name: "Hand Soap Lavender 3-Pack",
    category: "Home",
    subcategory: "Essentials",
    price: 14.97,
    date: "2024-12-19",
    member: "household",
    color: "Lavender",
    size: "12.5oz",
    emoji: "🧴"
  },
  {
    id: 38,
    brand: "Seventh Generation",
    name: "Laundry Detergent",
    category: "Home",
    subcategory: "Essentials",
    price: 16.49,
    date: "2024-11-12",
    member: "household",
    color: "Free & Clear",
    size: "100oz",
    emoji: "🧺"
  }
];
